/*
 * Sabre Digital: "You might also like" row.
 * Loaded by sections/recommended-products.liquid (product page and basket page).
 *
 * The row scrolls with the browser's own scrolling, so swiping and trackpads feel native.
 * This script only adds the two arrows (one screen of cards per press) and the progress line.
 * The theme loads the cards after the page, so the row is set up when it appears.
 */
(function () {
  'use strict';

  function setup(root) {
    if (root._sabreRecs) return;
    var track = root.querySelector('[data-recs-track]');
    if (!track) return;
    root._sabreRecs = true;

    var prev = root.querySelector('[data-recs-prev]');
    var next = root.querySelector('[data-recs-next]');
    var bar = root.querySelector('[data-recs-bar]');
    var queued = false;

    function update() {
      queued = false;
      var max = track.scrollWidth - track.clientWidth;
      var at = track.scrollLeft;
      var share = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;

      if (prev) prev.disabled = at <= 2;
      if (next) next.disabled = at >= max - 2;
      root.classList[max <= 2 ? 'add' : 'remove']('sabre-recs--static');

      if (bar) {
        bar.style.width = Math.min(100, share * 100) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (at / max) * (1 / share - 1) * 100 : 0) + '%)';
      }
    }

    function request() {
      if (queued) return;
      queued = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(update);
      else setTimeout(update, 50);
    }

    function page(direction) {
      var distance = track.clientWidth * direction;
      if (track.scrollBy) track.scrollBy({ left: distance, behavior: 'smooth' });
      else track.scrollLeft += distance;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        page(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        page(1);
      });
    }

    track.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    window.addEventListener('load', update);
    update();
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sabre-recs]'), setup);
  }

  function watch() {
    scan();
    if (!('MutationObserver' in window)) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-recommended-products]'), function (holder) {
      new MutationObserver(scan).observe(holder, { childList: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
